import React, { useMemo } from "react";
import { stripeSubscriptionScheduleStatuses, stripeSubscriptionStatuses } from "assets/constants/constants";
import { Chip } from "@material-ui/core";

const defaultStatus = {
  name: "Unknown",
  color: "#666",
  backgroundColor: "#f0f0f0",
  borderColor: "#d0d0d0"
};

const SubscriptionStatusChip = ({ stripe_subscription_id, stripe_subscription_schedule_id, stripe_subscription_schedule_status, stripe_subscription_status }) => {
  const statuses = useMemo(() => (stripe_subscription_id ? stripeSubscriptionStatuses : (stripe_subscription_schedule_id ? stripeSubscriptionScheduleStatuses : stripeSubscriptionStatuses)), [
    stripe_subscription_id,
    stripe_subscription_schedule_id
  ]);
  const stripeStatus = useMemo(() => {
    if (stripe_subscription_id) {
      return stripe_subscription_status;
    }
    if (stripe_subscription_schedule_id) {
      return stripe_subscription_schedule_status;
    }
    return stripe_subscription_status;
  }, [
    stripe_subscription_id,
    stripe_subscription_schedule_id,
    stripe_subscription_status,
    stripe_subscription_schedule_status
  ]);

  const statusConfig = useMemo(() => {
    if (!stripeStatus || !statuses[stripeStatus]) {
      return defaultStatus;
    }
    return statuses[stripeStatus];
  }, [stripeStatus, statuses]);

  return (
    <Chip
      label={statusConfig.name}
      variant="outlined"
      style={{
        border: "1px solid",
        borderColor: statusConfig.borderColor,
        backgroundColor: statusConfig.backgroundColor,
        borderRadius: "5px",
        fontWeight: "bold",
        color: statusConfig.color
      }}
    />
  );
};

export default SubscriptionStatusChip;
